import { Stack, Typography, useTheme } from "@mui/material";
import { MessageCircle } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getFirstName } from "web_myplann/Shared/Utils/getFirstName";

const ICON_SIZE = 32;

type Props = {
	name: string;
};

export const ChatEmptyState: FC<Props> = ({ name }) => {
	const theme = useTheme();
	const { t } = useResource();
	const firstName = getFirstName(name);

	return (
		<Stack
			alignItems="center"
			gap={theme.spacingTokens.xs}
			px={theme.spacingTokens.lg}
			pt={theme.spacingTokens.xxl}
		>
			<MessageCircle size={ICON_SIZE} color={theme.palette.grey[300]} />
			<Typography variant="bodyStrong" textAlign="center">
				{t(Resources.Chat.emptyTitle)}
			</Typography>
			<Typography
				variant="caption"
				textAlign="center"
				color={theme.palette.grey[500]}
			>
				{firstName
					? t(Resources.Chat.emptyDescription, { name: firstName })
					: t(Resources.Chat.emptyDescriptionWithoutName)}
			</Typography>
		</Stack>
	);
};
